import { Subject } from 'rxjs';

export const OnKeyPressSubject = new Subject();
